
import { useNavigate } from 'react-router-dom';

import '../styles/EmployeeMaster.css';
import LocationTable from '../components/LocationTable';

const Location = () => {
  const navigate = useNavigate();

  const handleAddClick = () => {
    
    navigate('/location/add');
  };

  

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Location Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Location
        </button>
      </div>

      <LocationTable />
    </div>
  );
};

export default Location